let docPaths = []

docPaths.push({
  path: `/v5/docs*`,
  name: `v5.docs`, // this is named v5.docs instead of five.docs to avoid the movingAcrossMajorVersion flag in SiteLink
  beforeEnter(to, from, next) {
    window.location.replace(FONTAWESOME.V5_DOCS_URL + to.path.slice(8))
  }
})

docPaths.push({
  path: `/v6/docs*`,
  name: `six.docs`,
  beforeEnter(to, from, next) {
    window.location.replace(FONTAWESOME.DOCS_URL + to.path.slice(8))
  }
})

docPaths.push({
  path: `/docs*`,
  name: `latest.docs`,
  beforeEnter(to, from, next) {
    if (to.path.startsWith('/docs/changelog') || to.path.startsWith('/v6/docs/changelog')) {
      next('/changelog')
    } else if (to.path.startsWith('/v5/docs/changelog')) {
      next('/changelog/v5')
    } else {
      window.location.replace(FONTAWESOME.DOCS_URL + to.path.slice(5))
    }
  }
})

export default docPaths
